(() => {
  if (window.atlasCroHeaderKeyboardReady) return;
  window.atlasCroHeaderKeyboardReady = true;

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !document.body.classList.contains('mobile-menu-open')) return;

    const menuToggle = document.querySelector('.head-slot-nav-mobile-link');
    menuToggle?.click();
  });
})();
